const actions = {
  SET_STATE: 'transaction/SET_STATE',
  FETCH_AGENT_PAYMENTS: 'transaction/FETCH_AGENT_PAYMENTS',
  FETCH_AGENT_PAYMENT_DETAILS: 'transaction/FETCH_AGENT_PAYMENT_DETAILS',
}

export default actions
